function getTimeInit() {
    const time = new Date()
    const opt = {
        year: time.getFullYear(),
        month:
            time.getMonth() + 1 > 9
                ? time.getMonth() + 1
                : '0' + (time.getMonth() + 1),
        day: time.getDate() > 9 ? time.getDate() : '0' + time.getDate(),
        hour: time.getHours() > 9 ? time.getHours() : '0' + time.getHours(),
        mintues:
            time.getMinutes() > 9 ? time.getMinutes() : '0' + time.getMinutes(),
        seconds:
            time.getSeconds() > 9 ? time.getSeconds() : '0' + time.getSeconds()
    }
    return (
        opt.year +
        '-' +
        opt.month +
        '-' +
        opt.day +
        '|' +
        opt.hour +
        ':' +
        opt.mintues +
        ':' +
        opt.seconds
    )
}

var watermark = {}

var setWatermark = waterOption => {
    const id = waterOption.id

    if (document.getElementById(id) !== null) {
        waterOption.el.removeChild(document.getElementById(id))
    }

    const can = document.createElement('canvas')
    can.width = 220
    can.height = 115

    const cans = can.getContext('2d')
    cans.rotate((-20 * Math.PI) / 180)

    const waterText =
        waterOption.account + ' ' + getTimeInit() + '内部资料，禁止外传'
    const arr = waterText.split('|')
    let uphight = 0
    for (let i = 0; i < arr.length; i++) {
        cans.font =
            '12px PingFang SC, PingFang-SC-Regular, Hiragino Sans GB, Microsoft YaHei, Vedana'
        cans.fillStyle = 'rgba(193, 193, 193, 0.15)'
        cans.textAlign = 'center'
        cans.textBaseline = 'Middle'
        cans.fillText(arr[i], 80, 90 + uphight)
        uphight += 20
    }

    const div = document.createElement('div')
    div.id = id
    div.style.pointerEvents = 'none'
    div.style.top = waterOption.top
    div.style.left = waterOption.left
    div.style.position = 'absolute'
    div.style.zIndex = waterOption.zIndex
    div.style.width = waterOption.width
    div.style.height = waterOption.height
    div.style.background =
        'url(' + can.toDataURL('image/png') + ') left top repeat'
    waterOption.el.appendChild(div)

    // loadMark(id, waterOption)
    return id
}

// const loadMark = (id, waterOption) => {
//     // 选择需要观察变动的节点
//     const targetNode = document.getElementById(id)
//
//     // 观察器的配置（需要观察什么变动）
//     const config = {
//         attributes: true, // 元素属性是否变更
//         childList: true, // 子元素是否添加或删除
//         subtree: true // 将监听范围扩大到目标节点整个节点树中的所有节点
//     }
//
//     // 当观察到变动时执行的回调函数
//     const callback = function(mutationsList, observer) {
//         observer.disconnect()
//
//         setWatermark(waterOption)
//     }
//
//     // 创建一个观察器实例并传入回调函数
//     const observer = new MutationObserver(callback)
//
//     // 以上述配置开始观察目标节点
//     observer.observe(targetNode, config)
//
//     // 之后，可停止观察
//     // observer.disconnect()
// }

// 该方法只允许调用一次
watermark.set = waterOption => {
    // let id = setWatermark(waterOption)
    setWatermark(waterOption)

    // setInterval(() => {
    //     if (document.getElementById(waterOption.parentId) !== null) {
    //         if (document.getElementById(id) === null) {
    //             id = setWatermark(waterOption)
    //         }
    //     }
    // }, 2000)

    // window.onresize = () => {
    //     setWatermark(waterOption)
    // }
}

export default watermark
